import React from "react";
import { iControlProps } from "../forms/types";
import DateV2 from "./DateV2";

type Props = iControlProps & {
    onChange: (date: string) => void;
    error: string;
    errorMessage?: string;
    description?: string;
    placeholder?: string;
    only_date_in_past?: boolean;
    only_date_in_future?: boolean;
    include_today_in_dates?: boolean;
    exclude_weekends?: boolean;
    min_date_rule?: string;
    max_date_rule?: string;
    min_date?: string;
    max_date?: string;
    excluded_dates?: string;
    calendarIconType?: string;
    dateFormat?: string;
    inputs: { id: string; label: string; name: string }[];
};

const DateV1 = (props: Props) => {
    const { calendarIconType } = props;
    const hideCalendarIcon = calendarIconType !== "calendar";
    return <DateV2 {...props} hide_calendar_icon={hideCalendarIcon} />;
};

export default DateV1;
